// NOTE: Please do not use this action directly.
import { saveSearchedLocation as service } from '@services/location.service';
import { SEARCHED_LOCATION } from '@location/actionTypes';
import updateFwfCity from '@commons/fwf/update/updateFwfCity';

const dispatchSearchedLocation = location => (dispatch, _, axios) => {
  if (location) {
    const { cityName, cityId } = location;
    if (cityName) updateFwfCity({ cityFullName: cityName, cityId });
  }

  return service({ axios, location }).then(() =>
    dispatch({ type: SEARCHED_LOCATION, payload: location }),
  );
};

export default dispatchSearchedLocation;
